import React from 'react'
import { featureData } from '../data/data'
import { Link } from 'react-router-dom'

export default function Feature() {
  return (
    <>
        <div className="row justify-content-center">
            {featureData.map((item,index)=>{
                return(
                    <div className="col-lg-3 col-md-6 mt-4 pt-2" key={index}>
                        <div className="position-relative p-4 bg-white shadow rounded overflow-hidden">
                            <div className="pe-4">
                                <Link to="#" className="link-title h5 text-dark">{item.title}</Link>
                                <p className="text-muted mb-3 mt-4">{item.desc}</p>
                                <Link to="#" className="btn btn-link primary">Buy Bitcoin <i className="mdi mdi-arrow-right align-middle"></i></Link>
                            </div>
                            <div className="position-absolute top-50 start-100 translate-middle z-0">
                                <img src={item.image} className="avatar avatar-large opacity-25" alt=""/>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    </>
  )
}
